import { LanguageId } from 'lib-knowledge-management-common/graphql';
import { createContext } from 'react';
import { StringParam, UrlUpdateType, useQueryParam } from 'use-query-params';

import { UseManagementLanguagesData } from '../hooks/useManagementLanguages';

export type LanguageContextType = UseManagementLanguagesData & {
  currentLanguage: ReturnType<typeof useLangParam>[0];
  setCurrentLanguage: ReturnType<typeof useLangParam>[1];
};

export const LanguageContext = createContext<LanguageContextType>(
  {} as LanguageContextType,
);

LanguageContext.displayName = 'LanguageContext';

/** Gets and sets the language param in the url */
export function useLangParam(): [
  LanguageId | null,
  (langId: LanguageId, updateType?: UrlUpdateType) => void,
] {
  const [langId, setLangId] = useQueryParam('langId', StringParam);
  return [(langId as LanguageId) || null, setLangId];
}
